import type { PriceBreakdownLine, QuoteResult } from '@ox/schema';

function formatMoney(currency: string, amount: number): string {
  return `${currency} ${amount.toFixed(2)}`;
}

export function PriceBreakdownSheet({
  quote,
  productName,
  colorLabel,
  articleCount = 1,
  onClose,
  sheetMode = false,
}: {
  quote: QuoteResult;
  productName: string;
  colorLabel: string;
  articleCount?: number;
  onClose: () => void;
  sheetMode?: boolean;
}) {
  const currency = quote.total.currency;
  const printLines: PriceBreakdownLine[] = quote.breakdown ?? [];

  return (
    <div
      className={
        sheetMode
          ? 'ox-sheet-backdrop ox-breakdown-backdrop'
          : 'ox-modal-backdrop ox-breakdown-backdrop'
      }
      onClick={onClose}
    >
      <div
        className={sheetMode ? 'ox-sheet ox-sheet-tall ox-breakdown-sheet' : 'ox-modal ox-breakdown-modal'}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label="Desglose de precios"
      >
        <header className={sheetMode ? 'ox-sheet-header' : undefined}>
          {sheetMode ? (
            <>
              <span className="ox-sheet-title">Desglose de precios</span>
              <button type="button" className="ox-sheet-x" onClick={onClose} aria-label="Cerrar">
                ✕
              </button>
            </>
          ) : (
            <>
              <h2>Desglose de precios</h2>
              <button type="button" onClick={onClose}>
                ✕
              </button>
            </>
          )}
        </header>
        <div className={sheetMode ? 'ox-sheet-body' : 'ox-breakdown-body'}>
          <ul className="ox-breakdown-list">
            {quote.lines.map((line) => (
              <li key={line.variantId}>
                <span>
                  {line.label ?? productName}
                  {colorLabel ? `, ${colorLabel}` : ''}
                  {line.quantity > 1 ? ` ×${line.quantity}` : ''}
                </span>
                <span>{formatMoney(currency, line.lineTotal.amount)}</span>
              </li>
            ))}
            {printLines.map((row) => (
              <li key={row.code}>
                <span>{row.label}</span>
                {row.included ? (
                  <span className="ox-breakdown-incl">Incluido</span>
                ) : (
                  <span>
                    {formatMoney(currency, row.amount * Math.max(1, articleCount))}
                  </span>
                )}
              </li>
            ))}
          </ul>
          <div className="ox-breakdown-total">
            <strong>Total</strong>
            <strong>{formatMoney(currency, quote.total.amount)}</strong>
          </div>
        </div>
      </div>
    </div>
  );
}
